<template>
  <div class="tips" @click.stop>
    <img
      class="image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e70385afc84024d7441a846c97ba4709.png"
      alt=""
    />
    <div class="title">暂未获取资格</div>
    <div class="text"
      >需先开通<span class="pink">大会员年卡或减脂卡</span
      ><br />才可以参与本次活动</div
    >
    <div class="btn" @click="bindClick">去开通</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    todayPrizeList() {
      let index = this.data.continuous_day
      return (
        (this.data.sign_task[index] && this.data.sign_task[index].goods_list) ||
        []
      )
    }
  },
  methods: {
    bindClick() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  text-align: center;
  width: 258px;
  padding: 0px 21px 35px;
  background: #fff;
  border-radius: 10px;

  .image {
    margin: 0 auto;
    margin-top: -50px;
    width: 136px;
    height: 105px;
    object-fit: contain;
    margin-bottom: 18px;
  }

  .title {
    font-weight: bold;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 27px;
    margin-bottom: 13px;
  }

  .text {
    font-weight: bold;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 18px;
    margin-bottom: 21px;

    .pink {
      color: rgba(255, 103, 32, 1);
    }
  }

  .btn {
    height: 44px;
    background: rgba(255, 103, 32, 1);
    border-radius: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 44px;
  }
}
</style>
